import { ScheduleUploadErrorCode } from '@heidi/schema/ml-scribe';

export const FAILURE_ERROR_CODES = [
  ScheduleUploadErrorCode.invalid_time,
  ScheduleUploadErrorCode.invalid_date,
];

export const WARNING_ERROR_CODES = [
  ScheduleUploadErrorCode.date_outside_range,
  ScheduleUploadErrorCode.conflict_overlap,
  ScheduleUploadErrorCode.past_date,
];

export const CSV_MAX_SESSIONS = 250;
